import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/home_v2/index'),
    },
    {
      path: '/contact-us',
      name: 'Contact us',
      // redirect: '/home',
      component: () => import('@/views/contact-us/index')
    },
    {
      path: '/index',
      name: '',
      component: () => import('@/views/home_v2/index')
    },
    {
      path: '/test',
      name: '',
      component: () => import('@/views/index/index')
    },
    {
      path: '/my-order',
      name: '',
      component: () => import('@/views/my-order/index')
    },
    {
      path: '/ai-home-agents',
      name: '',
      component: () => import('@/views/better-living-experience/index')
    },
    {
      path: '/blog',
      name: '',
      component: () => import('@/views/blog/index')
    },
    {
      path: '/careers',
      name: '',
      component: () => import('@/views/careers/index')
    },
    {
      path: '/ai-data-analytics',
      name: '',
      component: () => import('@/views/convenience-control/index')
    },
    {
      path: '/detail',
      name: '',
      component: () => import('@/views/detail/index')
    },
    {
      path: '/faq',
      name: '',
      component: () => import('@/views/faq/index')
    },
    {
      path: '/login',
      name: '',
      component: () => import('@/views/login/index')
    },
    {
      path: '/ai-powered-home-security-and-safety',
      name: '',
      component: () => import('@/views/making-homes-safer/index')
    },
    {
      path: '/marketplace-for-smart-devices',
      name: '',
      component: () => import('@/views/new-marketplace/index')
    },
    {
      path: '/price',
      name: '',
      component: () => import('@/views/price/index')
    },
    {
      path: '/privacy-policy',
      name: '',
      component: () => import('@/views/privacy-policy/index')
    },
    {
      path: '/privacy-policy.html',
      name: '',
      component: () => import('@/views/privacy-policy/index')
    },
    {
      path: '/ai-tools-for-video-editing-and-creation',
      name: '',
      component: () => import('@/views/safer-connected-communities/index')
    },
    {
      path: '/ai-property-management',
      name: '',
      component: () => import('@/views/smarter-manage/index')
    },
    {
      path: '/terms-of-services',
      name: '',
      component: () => import('@/views/terms-of-services/index')
    },
    {
      path: '/terms-of-services.html',
      name: '',
      component: () => import('@/views/terms-of-services/index')
    },
    {
      path: '/vault',
      name: '',
      component: () => import('@/views/vault/index')
    },
    {
      path: '/why-smartz',
      name: '',
      component: () => import('@/views/why-smartz/index')
    },
    {
      path: '/subscribe',
      name: '',
      component: () => import('@/views/subscribe/index')
    },
    {
      path: '/subscribe-plus',
      name: '',
      component: () => import('@/views/subscribe-plus/index')
    },
    {
      path: '/check-out',
      name: '',
      component: () => import('@/views/check-out/index')
    },
    {
      path: '/subscribe-basic',
      name: '',
      component: () => import('@/views/subscribe-basic/index')
    },
    {
      path: '/cart',
      name: '',
      component: () => import('@/views/cart/index')
    },
    {
      path: '/order-detail',
      name: '',
      component: () => import('@/views/order-detail/index')
    },
    {
      path: '/account',
      name: '',
      component: () => import('@/views/account/index')
    },
    {
      path: '/subscribe-success',
      name: '',
      component: () => import('@/views/subscribe-success/index')
    },
    {
      path: '/create-account',
      name: '',
      component: () => import('@/views/create-account/index')
    },
    {
      path: '/verify-email',
      name: '',
      component: () => import('@/views/verify-email/index')
    },
    {
      path: '/forgot-password',
      name: '',
      component: () => import('@/views/forgot-password/index')
    },
    {
      path: '/forgot-email',
      name: '',
      component: () => import('@/views/forgot-email/index')
    },
    {
      path: '/empty',
      name: '',
      component: () => import('@/views/empty/index')
    },
    // {
    //   path: '/sales-detail',
    //   name: '',
    //   component: () => import('@/views/deal/index')
    // },
    // {
    //   path: '/deal',
    //   name: '',
    //   component: () => import('@/views/deal/index')
    // },
    {
      path: '/deal',
      name: '',
      component: () => import('@/views/deal/index-250318')
    },
    {
      path: '/payment',
      name: '',
      component: () => import('@/views/payment/index')
    },
    {
      path: '/paymentx',
      name: '',
      component: () => import('@/views/paymentX/index')
    },
    {
      path: '/result',
      name: '',
      component: () => import('@/views/result/index')
    },
    {
      path: '/activate-result',
      name: '',
      component: () => import('@/views/activate-result/index')
    },
    {
      path: '/ai-agent',
      name: '',
      component: () => import('@/views/ai-agent/index')
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js